<template lang="pug">
  .itemList
    v-row.mb-2.listItem(:class="{ sendFailed: item.result == false, sendSuccess: item.result == true}", @click="showReminderHistoryDialog=true")
      v-col
        .p2.textColorDefault--text(:class="{ 'danger500--text': item.result == false, 'scheduledFont': item.result == true}") {{ item.income != null ? `#${item.id} ${item.income.name}` : shortDescription }}
      v-col.text-end
        .p2.textColorDefault--text.text-capitalize(:class="{ 'danger500--text': item.result == false, 'scheduledFont': item.result == true }") {{ statusDisplay }}
    reminder-history(v-if="showReminderHistoryDialog" :open.sync="showReminderHistoryDialog" :data="item" @stopped="$emit('stopped')")
</template>
<script>
import ReminderHistory from '@/components/yezzabook/dialogs/ReminderHistoryDialog.vue'

export default {
  name: "ReminderItemList",
  components: {ReminderHistory},
  data() {
    return {
      showReminderHistoryDialog: false,
    };
  },
  props: ['item'],
  filters: {
    
  },
  computed: {
    shortDescription(){
      const categories = this.item.expense.category_items
      const length = categories.length;
      if (length == 0) {
        return 'Null Description'
      }else{
        if (length == 1) {
          return this.textLimit(categories[0].description,30);
        }else{
          var more =  length - 1;
          return this.textLimit(categories[0].description,20) + " +" + more + " more";
        }
      }
    },
    statusDisplay(){
      const res = this.item.result
      if (res == true) {
        return 'sent'
      } else if (res == false) {
        return 'failed to send'
      } else {
        return this.convert24to12(this.item.send_time)
      }
    }
  },
  methods: {
    textLimit(text,max){
      if (text.length > max && this.$vuetify.breakpoint.width < 411 && this.$vuetify.breakpoint.width > 330) {
        return `${text.substring(0, max - 1)}...`
      }else if (text.length > max && this.$vuetify.breakpoint.width < 340) {
        return `${text.substring(0, max - 6)}...`
      }
      return text
    },
    convert24to12(timeString){
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? "AM" : "PM";
      return timeString = h + timeString.substr(2, 3) + ampm;
    }
  }
}
</script>
<style scoped>
.sendFailed {
  background-color: var(--v-dangerT08) !important;
}
.sendSuccess {
  background-color: var(--v-basic600T08) !important;
}
.listItem {
  background-color: var(--v-successT16);
  border-radius: 4px;
}
.scheduledFont{
  color: var(--v-primary400) !important;
}
</style>